import logo from './logo.svg';
import './App.css';
import React from 'react';
import Navbar from './components/navbar/navbar';
import Helper from './components/helper/helper';
import './components/i18n'; // Import i18n configuration
import Amount from './components/services/amount';
import PaymentStatus from './components/payment/PaymentStatus ';
import CareerPage from './components/career/CareerPage';
import CustomerServicePage from './components/customerService/CustomerServicePage';
import WhatsAppButton from './components/whatsAppButton/WhatsAppButton';

function App() {
  const path = window.location.pathname.toLowerCase();

  // Payment status URLs-ის შემოწმება
  const isPaymentStatusPage = path.includes('successurl') ||
                              path.includes('errorurl') ||
                              path.includes('cancelurl') ||
                              path.includes('success') ||
                              path.includes('error') ||
                              path.includes('cancel') ||
                              path.includes('callback');

  return (
    <React.StrictMode>
      <Navbar />
      {isPaymentStatusPage ? (
        <PaymentStatus />
      ) : path.includes("career") ? (
        <CareerPage />
      ) : path.includes("customer-service") ? (
        <CustomerServicePage />
      ) : path.includes("amount") ? (
        <Amount />
      ) : (
        <Helper />
      )}
      {!isPaymentStatusPage && <WhatsAppButton />}
    </React.StrictMode>
  );
}

export default App;